var map = {
	"./Curriculum Cover Page.jpg": 3170,
	"./DSC03545.jpg": 322,
	"./Event and Happending Cover page.jpg": 4244,
	"./HappyClassRoom.jpg": 5458,
	"./IMG-20191207-WA0166.jpg": 8750,
	"./IMG-20220322-WA0010.jpg": 6697,
	"./IMG20220810121748.jpg": 704,
	"./Pedagogy Cover.jpg": 8744,
	"./Social Impact Club.jpg": 6654,
	"./sportsclub.jpg": 6170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4868;